import { request } from "./http";

function qs(params = {}) {
  const sp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v == null || v === "") return;
    sp.set(k, String(v));
  });
  const s = sp.toString();
  return s ? `?${s}` : "";
}

function asObject(v) {
  return v && typeof v === "object" ? v : {};
}

function unwrapOkEnvelope(raw) {
  const obj = asObject(raw);
  if (Object.prototype.hasOwnProperty.call(obj, "item")) return asObject(obj.item);
  if (Object.prototype.hasOwnProperty.call(obj, "items")) {
    const maybe = obj.items;
    if (Array.isArray(maybe)) return { items: maybe };
    return asObject(maybe);
  }
  return obj;
}

function normalizeNotification(item = {}) {
  const n = asObject(item);
  return {
    id: n.id ?? n.notificationId ?? null,
    type: String(n.type || "SYSTEM").toUpperCase(),
    title: String(n.title || "Уведомление"),
    message: String(n.message ?? n.text ?? n.body ?? ""),
    linkUrl: String(n.linkUrl ?? n.url ?? n.href ?? ""),
    payload: asObject(n.payload),
    createdAt: n.createdAt ?? n.createdWhen ?? null,
    readAt: n.readAt ?? null,
    archivedAt: n.archivedAt ?? n.deletedWhen ?? null,
  };
}

function normalizeNotificationList(raw) {
  const data = unwrapOkEnvelope(raw);
  const itemsRaw = Array.isArray(data.items)
    ? data.items
    : Array.isArray(data.content)
      ? data.content
      : [];
  return {
    items: itemsRaw.map(normalizeNotification).filter((n) => n.id != null),
    nextCursor: data.nextCursor ?? data.cursorNext ?? data.next ?? null,
    unreadCount: Number.isFinite(Number(data.unreadCount)) ? Number(data.unreadCount) : null,
  };
}

function normalizeNotificationSettings(raw = {}) {
  const s = unwrapOkEnvelope(raw);
  return {
    profileSubscription: Boolean(s.profileSubscription),
    favoriteAdded: Boolean(s.favoriteAdded),
    chatMessage: Boolean(s.chatMessage),
    chatReaction: Boolean(s.chatReaction),
    blogNewPost: Boolean(s.blogNewPost),
    blogCommentOnMyPublication: Boolean(s.blogCommentOnMyPublication),
    blogReactionOnMyPublication: Boolean(s.blogReactionOnMyPublication),
    forumCommentOnMyPublication: Boolean(s.forumCommentOnMyPublication),
    forumReactionOnMyPublication: Boolean(s.forumReactionOnMyPublication),
    commentReply: Boolean(s.commentReply),
    sessionReminder: Boolean(s.sessionReminder),
    storyNew: Boolean(s.storyNew),
    storyReactionOnMyStory: Boolean(s.storyReactionOnMyStory),
    storyReplyOnMyStory: Boolean(s.storyReplyOnMyStory),
    podcastNew: Boolean(s.podcastNew),
    podcastEpisodeNew: Boolean(s.podcastEpisodeNew),
    podcastCommentOnMyPublication: Boolean(s.podcastCommentOnMyPublication),
    podcastReactionOnMyPublication: Boolean(s.podcastReactionOnMyPublication),
    literatureNew: Boolean(s.literatureNew),
    literatureCommentOnMyPublication: Boolean(s.literatureCommentOnMyPublication),
    literatureReactionOnMyPublication: Boolean(s.literatureReactionOnMyPublication),
  };
}

function normalizeSettingsMeta(raw) {
  const data = unwrapOkEnvelope(raw);
  const items = Array.isArray(data.items) ? data.items : Array.isArray(raw) ? raw : [];
  return items
    .map((x) => asObject(x))
    .filter((x) => x.key)
    .map((x) => ({
      key: String(x.key),
      title: String(x.title || x.key),
      description: String(x.description || ""),
      eventTypes: Array.isArray(x.eventTypes) ? x.eventTypes.map((y) => String(y || "")) : [],
      defaultEnabled: Boolean(x.defaultEnabled),
    }));
}

export const notificationsApi = {
  list: async ({ onlyUnread = false, limit = 20, cursor } = {}) => {
    const raw = await request(`/api/notifications${qs({ onlyUnread, limit, cursor })}`);
    return normalizeNotificationList(raw);
  },

  unreadCount: () => request("/api/notifications/unread-count"),

  markRead: (id) => request(`/api/notifications/${id}/read`, { method: "POST" }),

  markAllRead: () => request("/api/notifications/read-all", { method: "POST" }),

  archive: (id) => request(`/api/notifications/${id}/archive`, { method: "POST" }),

  getSettings: async () => {
    const raw = await request("/api/me/notification-settings");
    return normalizeNotificationSettings(raw);
  },

  getSettingsMeta: async () => {
    const raw = await request("/api/me/notification-settings/meta");
    return normalizeSettingsMeta(raw);
  },

  updateSettings: async (patch = {}) => {
    const raw = await request("/api/me/notification-settings", {
      method: "PUT",
      json: patch,
    });
    return normalizeNotificationSettings(raw);
  },
};
